class YdFooter extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.attachEventListeners();
  }

  attachEventListeners() {
    // 处理 Order 按钮点击事件
    const orderBtn = this.querySelector('.sa-footer__order-btn');
    if (orderBtn) {
      orderBtn.addEventListener('click', () => {
        const orderAction = orderBtn.getAttribute('data-order-action');
        
        // 如果有自定义 action，执行它
        if (orderAction) {
          try {
            // 使用 Function 构造函数来执行用户提供的 JavaScript 代码
            new Function(orderAction)();
          } catch (error) {
            console.error('Error executing order action:', error);
          }
        } else {
          // 默认行为：打开 order dialog（使用全局方法）
          if (window.openOrderDialog && typeof window.openOrderDialog === 'function') {
            window.openOrderDialog({
              title: 'Talk to our team',
              description: 'Connect with our sales team to explore how our cutting-edge technology can empower your research today.',
              privacyUrl: '/pages/policy',
              termsUrl: '/pages/terms-of-use'
            });
          }
        }
      });
    }

    // 社交媒体图标 hover：只有被 hover 的图标变化（CSS :hover 加深边框），
    // 其他图标保持不变（不再变暗）。
  }
}

customElements.define('sa-footer', YdFooter);
